// T-gap-1226 (a): decides when the BosAI widget must drop its chat state because
// the signed-in identity changed. `settled` is the last non-loading user id seen
// (undefined = nothing settled yet). The first settled value is the baseline;
// any later change, including to or from null, resets.
export type AuthIdentity = { loading: boolean; userId: string | null };

export function nextAuthIdentity(
  settled: string | null | undefined,
  next: AuthIdentity,
): { settled: string | null | undefined; reset: boolean } {
  if (next.loading) return { settled, reset: false };
  if (settled === undefined) return { settled: next.userId, reset: false };
  return { settled: next.userId, reset: settled !== next.userId };
}
